var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"container"},[_c('div',{staticClass:"notFound"},[_c('h1',[_vm._v("Vi hittar inte det du söker!")])])])}]

export { render, staticRenderFns }